import { render, staticRenderFns } from "./TillsList.vue?vue&type=template&id=05b055d2&scoped=true&"
import script from "./TillsList.vue?vue&type=script&lang=js&"
export * from "./TillsList.vue?vue&type=script&lang=js&"
import style0 from "./TillsList.vue?vue&type=style&index=0&id=05b055d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b055d2",
  null
  
)

export default component.exports